/**
 * Accès au panneau Métriques — v1 réservée au superadmin (product owner Dozka).
 *
 * Gate sur `isSuperadmin` — MÊME source que le contrôle backend
 * (`session.is_superadmin` sur `/api/metrics/*`), donc front et back s'accordent
 * par construction, quel que soit l'email du compte owner. (Un gate par email
 * en dur cassait : le compte superadmin réel n'est pas forcément l'email git.)
 * Même idiome que `channels/access.ts` (`useCanUseChannels`).
 */
import { useSession } from "@/core/auth/useSession";

export function useCanUseMetrics(): boolean {
  const { user } = useSession();
  return user?.isSuperadmin === true;
}
